export const ENTITY = "ENTITY";
export const INDIVIDUAL = "INDIVIDUAL";
export const JOINT = "JOINT";
export const TRUST = "TRUST";

export const ENTITY_TYPE = {
  [INDIVIDUAL]: "Individual",
  [ENTITY]: "Entity",
};

export const TA_ACCOUNT_TYPE = {
  [INDIVIDUAL]: "Individual",
  [JOINT]: "Joint",
  [TRUST]: "Trust",
  [ENTITY]: "Entity",
};

export const JOINT_SUB_TYPE = {
  "JT TEN": "Joint Tenants with Right of Survivorship",
  "TEN ENT": "Tenants by Entireties",
  "TEN COM": "Tenants in Common",
  "COMM PRO": "Community Property",
};

export const TRUST_SUB_TYPE = {
  "Trust - Revocable": "Revocable",
  "Trust - Irrevocable or Institution": "Irrevocable or Institution",
};

export const ENTITY_SUB_TYPE = [
  "Corporation",
  "LLC",
  "Partnership",
  "Association or Club",
  "Charity",
  "Religious Organization",
  "School",
  "Broker",
  "Financial Institution",
  "IRA",
  "Pension or Profit Sh Plan - Revocable",
  "Pension or Profit Sh Plan - Irrevocable or Institution",
];

export const TA_ACCOUNT_TYPE_OPTIONS = Object.entries(TA_ACCOUNT_TYPE).map(
  ([value, label]) => ({ value, label }),
);

export const ENTITY_TYPE_OPTIONS = Object.entries(ENTITY_TYPE).map(
  ([value, label]) => ({ value, label }),
);

export const ENTITY_SUB_TYPE_OPTIONS = ENTITY_SUB_TYPE.map((value) => ({
  value: value,
  label: value,
}));

export const JOINT_SUB_TYPE_OPTIONS = Object.entries(JOINT_SUB_TYPE).map(
  ([value, label]) => ({ value, label }),
);

export const TRUST_SUB_TYPE_OPTIONS = Object.entries(TRUST_SUB_TYPE).map(
  ([value, label]) => ({ value, label }),
);

export const US_CITIZEN = "US_CITIZEN";
export const INTERNATIONAL = "INTERNATIONAL";

export const CITIZENSHIP = {
  [US_CITIZEN]: "US Citizen",
  [INTERNATIONAL]: "International",
};

export const CITIZENSHIP_OPTIONS = Object.entries(CITIZENSHIP).map(
  ([value, label]) => ({ value, label }),
);
